import localeConfig from '../config/locale.config';
import { setLocaleDefaults } from './dateUtils';

/** Runtime overrides from GET /api/admin/payments/config (same source as GST). */
let runtimeCurrency = localeConfig.currency.code || 'NZD';
let runtimeLocale = localeConfig.intlLocale || 'en-NZ';

export function setMoneyDefaults({ currency, locale, timezone } = {}) {
  if (currency) runtimeCurrency = String(currency).toUpperCase();
  if (locale) runtimeLocale = String(locale);
  if (locale || timezone) {
    setLocaleDefaults({ locale, timezone });
  }
}

export function getDefaultCurrency() {
  return runtimeCurrency;
}

/**
 * Format a monetary amount for display.
 * Prefers an explicit ISO currency from the API; otherwise uses config default.
 */
export function formatMoney(amount, currency = runtimeCurrency) {
  if (amount == null || amount === '' || Number.isNaN(Number(amount))) {
    return '—';
  }
  const code = (currency || runtimeCurrency || 'NZD').toUpperCase();
  try {
    return new Intl.NumberFormat(runtimeLocale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    return `${code} ${Number(amount).toFixed(2)}`;
  }
}

export function currencySymbol(currency = runtimeCurrency) {
  const code = (currency || runtimeCurrency || 'NZD').toUpperCase();
  if (code === (localeConfig.currency.code || '').toUpperCase()) {
    return localeConfig.currency.symbol;
  }
  try {
    const parts = new Intl.NumberFormat(runtimeLocale, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'narrowSymbol',
    }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value || code;
  } catch {
    return code;
  }
}

export default formatMoney;
